import { Link2Off } from "lucide-react";

export interface EmbeddedPageItemProps {
  url: string;
  title: string;
}

export function EmbeddedPageItem({ url, title }: EmbeddedPageItemProps) {
  
  const getIsValid = (url: string) => {
    const urlRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
    console.log(!!url.match(urlRegex));
    return !!url.match(urlRegex);
  };

  if (!getIsValid(url)) {
    return (
      <div className="w-full h-full bg-gray-200 grid place-items-center">
        <div className="absolute top-0 right-0 bottom-0 left-0 z-10"></div>
        <span className="flex justify-center text-gray-700 text-md font-semibold gap-x-2">
          <Link2Off className="h-8 w-8"/>
          Ingen giltig länk angiven
        </span>
    </div>
    )
  }
  return (
    <div className="h-full w-full">
      <div className="absolute top-0 right-0 bottom-0 left-0 z-10"></div>
      <iframe src={url} title={title} className="w-full h-full" ></iframe>
    </div>
  );
}